import clsx from 'clsx';

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
  return (
    <div className={clsx('animate-pulse bg-surface-2 rounded', className)} />
  );
}

export function SkeletonCard({ className }: SkeletonProps) {
  return (
    <div className={clsx('rounded-lg bg-surface-2 p-3 space-y-2 animate-pulse', className)}>
      <div className="flex items-center gap-2">
        <Skeleton className="w-8 h-8 rounded-md flex-shrink-0" />
        <div className="flex-1 space-y-1.5">
          <Skeleton className="h-3 w-3/4" />
          <Skeleton className="h-2.5 w-1/2" />
        </div>
        <Skeleton className="w-12 h-5 rounded-md flex-shrink-0" />
      </div>
      <Skeleton className="h-2 w-full" />
      <div className="flex gap-2 pt-1">
        <Skeleton className="h-5 w-16 rounded-full" />
        <Skeleton className="h-5 w-12 rounded-full" />
      </div>
    </div>
  );
}

export function SkeletonGameCard({ className }: SkeletonProps) {
  return (
    <div className={clsx('rounded-lg bg-surface-2 p-3 animate-pulse', className)}>
      <div className="flex items-center justify-between mb-2">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-4 w-14 rounded-md" />
      </div>
      <div className="flex items-center justify-between gap-2">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-3 w-6" />
        <Skeleton className="h-4 w-20" />
      </div>
      <div className="flex gap-2 mt-2">
        <Skeleton className="h-5 w-14 rounded" />
        <Skeleton className="h-5 w-14 rounded" />
        <Skeleton className="h-5 w-14 rounded" />
      </div>
    </div>
  );
}

export function SkeletonOpportunityRow({ className }: SkeletonProps) {
  return (
    <div className={clsx('rounded-lg bg-surface-2 p-2.5 flex items-center gap-2 animate-pulse', className)}>
      <Skeleton className="w-1 h-10 rounded-full flex-shrink-0" />
      <div className="flex-1 space-y-1.5">
        <Skeleton className="h-3 w-2/3" />
        <Skeleton className="h-2.5 w-1/2" />
      </div>
      <div className="flex flex-col items-end gap-1 flex-shrink-0">
        <Skeleton className="h-4 w-10 rounded" />
        <Skeleton className="h-3 w-8" />
      </div>
    </div>
  );
}
